import React, { useState } from 'react';
import { Container, FileInfo, Preview, PreviewBadge, FileRow, FileActions } from './styles';
import { MdCheckCircle, MdLink, MdPictureAsPdf, MdVideocam, MdInsertDriveFile, MdClose } from 'react-icons/md';
import { getFileKind } from 'utils/mediaFile';

function FilePreview({ file }) {
    const kind = getFileKind(file);
    const src = file.viewURL || file.url;

    if (kind === 'image' && src) {
        return <Preview src={src} title={file.name} />;
    }

    if (kind === 'video') {
        return (
            <PreviewBadge title="Vídeo">
                <MdVideocam size={22} color="#1565c0" />
            </PreviewBadge>
        );
    }

    if (kind === 'pdf') {
        return (
            <PreviewBadge title="PDF">
                <MdPictureAsPdf size={22} color="#c62828" />
            </PreviewBadge>
        );
    }

    return (
        <PreviewBadge title="Arquivo">
            <MdInsertDriveFile size={22} color="#616161" />
        </PreviewBadge>
    );
}

export default function FileList({ files, onDelete, action, disabled }) {
    const [previewVideo, setPreviewVideo] = useState(null);

    return (
        <Container>
            {files.map((uploadedFile) => {
                const kind = getFileKind(uploadedFile);
                const src = uploadedFile.viewURL || uploadedFile.url;
                const canDelete =
                    action !== 'view' &&
                    onDelete &&
                    ((!uploadedFile.url) || (uploadedFile.url && disabled !== true && uploadedFile.type !== 2));

                return (
                    <li key={uploadedFile.id}>
                        <FileRow>
                            <FileInfo>
                                <FilePreview file={uploadedFile} />
                                <div>
                                    <strong>{uploadedFile.name}</strong>
                                    <span>{uploadedFile.readableSize}</span>
                                </div>
                            </FileInfo>

                            <FileActions>
                                {kind === 'video' && src && (
                                    <button type="button" className="preview-btn" onClick={() => setPreviewVideo(uploadedFile)}>
                                        Pré-visualizar
                                    </button>
                                )}
                                {uploadedFile.url && (
                                    <a href={uploadedFile.url} target="_blank" rel="noopener noreferrer" title="Abrir">
                                        <MdLink size={22} color="#222" />
                                    </a>
                                )}
                                {uploadedFile.uploaded && <MdCheckCircle size={22} color="#78e5d5" />}
                                {canDelete && (
                                    <button type="button" className="delete-btn" onClick={() => onDelete(uploadedFile.id)}>
                                        Excluir
                                    </button>
                                )}
                            </FileActions>
                        </FileRow>
                    </li>
                );
            })}

            {previewVideo && (previewVideo.viewURL || previewVideo.url) && (
                <div
                    role="dialog"
                    aria-modal="true"
                    className="video-modal-backdrop"
                    onClick={() => setPreviewVideo(null)}
                >
                    <div className="video-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="video-modal-header">
                            <span>{previewVideo.name}</span>
                            <button type="button" onClick={() => setPreviewVideo(null)} aria-label="Fechar">
                                <MdClose size={24} />
                            </button>
                        </div>
                        <video src={previewVideo.viewURL || previewVideo.url} controls autoPlay playsInline>
                            Seu navegador não suporte a pré-visualização deste vídeo.
                        </video>
                    </div>
                </div>
            )}
        </Container>
    );
}
